// formats Date Object to string in "YYYY-MM-DD HH:mm:ss" format
export const formatDateTime = (
  date: Date,
  timeRequired: boolean = false
): string => {
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  if (timeRequired)
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  else return `${year}-${month}-${day}T00:00:00.000+00:00`;
};

// formats string to Date Object in "YYYY-MM-DD HH:mm:ss" format
export const convertStringToDateTime = (date: string): Date => {
  // currently we date in 2024-12-24T00:00:00.000+00:00 format so we need to convert it to YYYY-MM-DD HH:mm:ss
  date = `${date.split("T")[0]} 00:00:00`;
  let arr = date.split(/-|\s|:/); // split string and create array.
  return new Date(
    Number(arr[0]),
    Number(arr[1]) - 1,
    Number(arr[2]),
    Number(arr[3]),
    Number(arr[4]),
    Number(arr[5])
  ); // decrease month value by 1
};

// formats Date Object to string in "YYYY-MM-DD" format
export const formatDate = (date: Date): string => {
  // this if is used for special case where we fetch date range edits and get them as string
  // as that created a type issue so I converted that to Date object right here
  if(typeof date === "string") date = new Date(date);

  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

// Format date like yyyy-mm-dd-yyyy-mm-dd to mm/dd/yyyy - mm/dd/yyyy
export const formatFromAndToDateString = (date: string): string => {
  const [fromYear, fromMonth, fromDay, toYear, toMonth, toDay] = date.split("-");
  return `${fromMonth}/${fromDay}/${fromYear} - ${toMonth}/${toDay}/${toYear}`;
}

// Formatted Date util like from yyyy/mm/dd to mm/dd/yyyy
export const formatDateString = (date: string): string => {
  const [year, month, day] = date.split("-");
  return `${month}/${day}/${year}`;
}

// Format Date like 
export const formatISODateString = (date: string): string => {
  const [year, month, day] = date.split("T")[0].split("-");
  return `${month}/${day}/${year}`;
}
